if (typeof FeaturedBrandsCarousel === 'undefined') {
    class FeaturedBrandsCarousel extends HTMLElement {
        constructor() {
            super();
            this.handleViewportChange = this.handleViewportChange.bind(this);
            this.mediaQuery = window.matchMedia('(max-width: 767px)');
        }

        connectedCallback() {
            this.mediaQuery.addEventListener('change', this.handleViewportChange);
            this.syncMainCardSlide();
            this.initSwiper();
        }

        disconnectedCallback() {
            this.mediaQuery.removeEventListener('change', this.handleViewportChange);
            this.destroySwiper();
        }

        getMainCard() {
            const section = this.closest('.shopify-section');
            if (!section) return null;

            return Array.from(section.querySelectorAll('.brands-main-card')).find((card) => {
                return !card.closest('featured-brands-carousel');
            });
        }

        syncMainCardSlide() {
            const wrapper = this.querySelector('.swiper-wrapper');
            if (!wrapper) return;

            const existing = wrapper.querySelector('[data-main-card-slide]');
            if (existing) existing.remove();

            if (!this.mediaQuery.matches) return;

            const mainCard = this.getMainCard();
            if (!mainCard) return;

            const slide = document.createElement('div');
            slide.className = 'swiper-slide p:h-auto p:max-w-full p:md:w-(--slide-width)! p:md:min-w-(--slide-width)! p:max-md:w-(--slide-width-mobile)! p:max-md:min-w-(--slide-width-mobile)!';
            slide.setAttribute('data-main-card-slide', '');

            const clone = mainCard.cloneNode(true);
            clone.removeAttribute('id');
            clone.removeAttribute('hidden');
            clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
                el.removeAttribute('data-shopify-editor-block');
            });
            clone.removeAttribute('data-shopify-editor-block');

            slide.appendChild(clone);
            wrapper.prepend(slide);
        }

        handleViewportChange() {
            this.reinitSwiper();
        }

        getSwiperConfig(swiperContainer) {
            const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
            const edgeOffset = this.mediaQuery.matches ? 16 : 0;

            return {
                a11y: true,
                slidesPerView: 'auto',
                loop: slideCount > 1,
                watchOverflow: true,
                spaceBetween: 16,
                slidesOffsetBefore: edgeOffset,
                slidesOffsetAfter: edgeOffset,
                pauseOnMouseEnter: false,
                watchSlidesProgress: true,
                preventClicks: false,
                preventClicksPropagation: false,
                navigation: {
                    prevEl: this.querySelector('.swiper-prev'),
                    nextEl: this.querySelector('.swiper-next')
                },
                mousewheel: {
                    enabled: !window.isSafari(),
                    forceToAxis: window.isSafari() ? false : true,
                    thresholdDelta: 10
                }
            };
        }

        initSwiper() {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            whenReady('Swiper', () => {
                if (!this.isConnected || this.swiper) return;

                try {
                    this.swiper = new Swiper(swiperContainer, this.getSwiperConfig(swiperContainer));
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        cleanupSwiperContainer() {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer) return;

            swiperContainer.classList.remove(
                'swiper-initialized',
                'swiper-horizontal',
                'swiper-vertical',
                'swiper-backface-hidden',
                'swiper-watch-progress'
            );
            swiperContainer.removeAttribute('style');
        }

        reinitSwiper() {
            this.destroySwiper();
            this.cleanupSwiperContainer();
            this.syncMainCardSlide();
            this.initSwiper();
        }

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    if (!window.customElements.get('featured-brands-carousel')) {
        window.customElements.define('featured-brands-carousel', FeaturedBrandsCarousel);
    }

    function reinitSectionCarousels(section) {
        if (!section) return;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                section.querySelectorAll('featured-brands-carousel').forEach((carousel) => {
                    carousel.reinitSwiper();
                });
            });
        });
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            reinitSectionCarousels(event.target);
        });
    }
}
